/**
 * The data related to the wrapper application.
 * 
 * @author Stan Hurks
 */
export default class StorageDataModelWrapper {

    /**
     * The selected tab index
     */
    public selectedTab: number = 0
}